import { Link } from "react-router-dom";
import { ScrollText, ChevronRight } from "lucide-react";
import { useAuth } from "@/auth/useAuth.js";
import { roleLabel } from "@/lib/role.js";
import { env } from "@/env.js";
import { Badge } from "@/components/ui/badge.js";
import { RoleGate } from "@/components/RoleGate.js";

export default function Settings(): JSX.Element {
  const { email, role, org_id } = useAuth();

  return (
    <div className="space-y-6">
      <header>
        <h1 className="text-h1 font-display text-ink">Team & setup</h1>
        <p className="text-body text-ink-soft">Profilo, organizzazione, integrazioni</p>
      </header>

      <section className="space-y-3 rounded border border-rule bg-surface p-5">
        <h2 className="text-h2 font-display text-ink">Il tuo profilo</h2>
        <dl className="grid grid-cols-[140px_1fr] gap-2 text-body">
          <dt className="font-mono text-meta uppercase tracking-wider text-ink-mute">Email</dt>
          <dd className="text-ink">{email ?? "—"}</dd>
          <dt className="font-mono text-meta uppercase tracking-wider text-ink-mute">Ruolo</dt>
          <dd><Badge tone="accent">{role ? roleLabel(role) : "—"}</Badge></dd>
          <dt className="font-mono text-meta uppercase tracking-wider text-ink-mute">Org</dt>
          <dd className="font-mono text-meta text-ink-soft">{org_id ?? "—"}</dd>
        </dl>
      </section>

      <RoleGate min="admin">
        <section className="space-y-3 rounded border border-rule bg-surface p-5">
          <h2 className="text-h2 font-display text-ink">Organizzazione</h2>
          <p className="text-body text-ink-soft">
            Slug: <span className="font-mono text-ink">avestate</span> · Lingue:{" "}
            <span className="font-mono text-ink">it, en, de</span>
          </p>
          <p className="text-meta text-ink-mute">
            Gestione team (aggiunta utenti, ruoli) disponibile in fase 2 — al momento la membership si crea via script
            `scripts/seed-owner.sh` (Plan 1) o via SQL diretto su Supabase.
          </p>
        </section>
      </RoleGate>

      <RoleGate min="owner">
        <section className="space-y-3 rounded border border-rule bg-surface p-5">
          <h2 className="text-h2 font-display text-ink">Brand · placeholder</h2>
          <p className="text-body text-ink-soft">
            Logo, palette, dominio personalizzato: configurazione in arrivo (multi-tenant phase). Per ora il brand è fissato su <strong>av/estate</strong>.
          </p>
        </section>
      </RoleGate>

      <RoleGate min="admin">
        <section className="space-y-3 rounded border border-rule bg-surface p-5">
          <h2 className="text-h2 font-display text-ink">Sicurezza &amp; registro</h2>
          <p className="text-body text-ink-soft">
            Registro attività <strong>append-only</strong>: ogni modifica a immobili, pubblicazioni,
            approvazioni e team viene tracciata (chi, cosa, quando, con stato prima/dopo). Immutabile —
            per accountability interna e conformità GDPR.
          </p>
          <Link
            to="/audit"
            className="inline-flex items-center gap-2 rounded border border-rule bg-surface-2 px-3 py-2 text-body text-ink transition-colors hover:border-accent"
          >
            <ScrollText className="size-4 text-accent" />
            Apri registro attività
            <ChevronRight className="size-4 text-ink-mute" />
          </Link>
        </section>
      </RoleGate>

      <section className="space-y-3 rounded border border-rule bg-surface p-5">
        <h2 className="text-h2 font-display text-ink">Integrazioni · stato</h2>
        <ul className="space-y-2 text-body">
          <li className="flex items-center justify-between">
            <span>Worker API</span>
            <span className="font-mono text-meta text-ink-mute truncate">{env.VITE_API_BASE_URL}</span>
          </li>
          <li className="flex items-center justify-between">
            <span>Supabase</span>
            <span className="font-mono text-meta text-ink-mute truncate">{env.VITE_SUPABASE_URL}</span>
          </li>
        </ul>
      </section>
    </div>
  );
}
